import type { ResourceItem } from './types';

const STORAGE_KEY = 'krysalis_resources_catalog_overlay_v1';

/** Interim authoring store until content API lands (admin upload WBS seq 3). */
export function readResourceOverlay(): ResourceItem[] {
  if (typeof localStorage === 'undefined') return [];
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed.filter(isResourceItem);
  } catch {
    return [];
  }
}

export function writeResourceOverlay(items: ResourceItem[]): void {
  if (typeof localStorage === 'undefined') return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
}

export function upsertResourceOverlayItem(item: ResourceItem): ResourceItem[] {
  const current = readResourceOverlay();
  const idx = current.findIndex((row) => row.id === item.id || row.slug === item.slug);
  const next =
    idx >= 0
      ? current.map((row, i) => (i === idx ? item : row))
      : [item, ...current];
  writeResourceOverlay(next);
  return next;
}

export function removeResourceOverlayItem(id: string): ResourceItem[] {
  const next = readResourceOverlay().filter((row) => row.id !== id);
  writeResourceOverlay(next);
  return next;
}

function isResourceItem(value: unknown): value is ResourceItem {
  if (!value || typeof value !== 'object') return false;
  const row = value as ResourceItem;
  return (
    typeof row.id === 'string' &&
    typeof row.slug === 'string' &&
    typeof row.title === 'string' &&
    typeof row.summary === 'string' &&
    typeof row.kind === 'string' &&
    typeof row.visibility === 'string' &&
    typeof row.publishedAt === 'string'
  );
}

export function slugifyResourceTitle(title: string): string {
  return title
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 80);
}
